import React, { useEffect } from 'react';

import SendMessageIcon from '../assets/icon/sendMessage.svg';
import XIcon from '../assets/icon/x.svg';

import '../css/chat.css';

const ChatArea = ({
  backgroundColorPrincipal,
  corFundo,
  backgroundImage,
  corTextoOperador,
  corTextoCliente,
  corCaixaOperador,
  corCaixaCliente,
  corNomeOperadorCliente,
  corTitulo,
  opacidadeImagem,
}: {
  backgroundColorPrincipal: string;
  corFundo: string;
  backgroundImage: string;
  corTextoOperador: string;
  corTextoCliente: string;
  corCaixaOperador: string;
  corCaixaCliente: string;
  corNomeOperadorCliente: string;
  corTitulo: string;
  opacidadeImagem: number;
}): JSX.Element => {
  const blurOverlay: React.CSSProperties = {
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
  };

  return (
    <div className="h-100 w-100 position-relative">
      <div
        className="h-100 w-100"
        style={{
          backgroundImage: !backgroundImage
            ? 'none'
            : `linear-gradient(rgba(255, 255, 255, ${
                opacidadeImagem / 100
              }), rgba(255, 255, 255, ${opacidadeImagem / 100})), url('${
                process.env.REACT_APP_API_URL
              }/BackGroundImage/${backgroundImage}')`,
          backgroundColor: !backgroundImage ? corFundo : 'transparent',
          backgroundSize: '100% 100%', // Define o tamanho da imagem se houver imagem.
          backgroundPosition: 'center', // Posição da imagem.
          backgroundRepeat: 'no-repeat', // Impede repetição da imagem.
        }}
      >
        <div
          className="position-absolute"
          style={corFundo !== '' ? {} : blurOverlay}
        />
        <div className="d-flex justify-content-center">
          <div
            className="d-flex top-0 align-items-center justify-content-around"
            style={{
              width: '86%',
              position: 'relative',
              borderRadius: '0rem 0rem 0.6875rem 0.6875rem',
              height: '1.6rem',
              backgroundColor: backgroundColorPrincipal,
            }}
          >
            <span
              className="p-0 m-0 border border-2 border-dark-subtle px-1 py1 text-black-50"
              style={{ fontSize: '0.6rem', fontWeight: '600' }}
            >
              Logo
            </span>
            <p
              className="p-0 m-0"
              style={{
                color: `${corTitulo}`,
                fontSize: '0.8rem',
                fontWeight: '500',
              }}
            >
              Suporte Online
            </p>
            <img
              src={XIcon}
              alt="X"
              style={{ width: '0.5rem', height: '0.5rem' }}
            />
          </div>
        </div>

        <div className="div-container-msg-main position-relative h-100">
          <div
            className="overflow-auto mw-100 mt-1"
            style={{ maxHeight: '86%' }}
          >
            <div
              className="d-flex flex-column mw-100 ms-md-4 me-md-3 ms-1 me-1
                 align-items-start"
            >
              <div className="d-flex flex-column mw-100 w-100 div-container-msg  align-items-start">
                <p
                  className="ms-1 mb-0 text-uppercase"
                  style={{
                    color: `${corNomeOperadorCliente}`,
                    fontSize: '0.3rem',
                  }}
                >
                  Administrador 20:50:46
                </p>
                <div
                  className="div-msg"
                  style={{
                    color: `${corNomeOperadorCliente}`,
                    backgroundColor: `${corCaixaOperador}`,
                    borderRadius: '0rem 0.625rem 0.625rem',
                    maxWidth: '50%',
                  }}
                >
                  <div
                    style={{
                      color: `${corTextoOperador}`,
                      fontSize: '0.25rem',
                      textAlign: 'justify',
                    }}
                    className="text-html ms-2 me-2 fs-lg-1"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue nibh eget turpis sollicitudin aliquam convallis vitae eros. Vivamus pretium feugiat mi, ut consectetur lectus consectetur sed. Ut vehicula auctor dignissim. Curabitur non semper leo. Sed eget interdum nibh. Donec mattis quam vulputate nisl molestie malesuada. Proin a venenatis enim, ac blandit ligula. Nulla ut dolor blandit, ultrices risus ac, tempus enim. Etiam ullamcorper cursus ipsum, ac sollicitudin ex sodales eget.',
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column mw-100 me-md-4 me-md-3 ms-1 me-1
                 align-items-end"
            >
              <div className="d-flex flex-column mw-100 w-100 div-container-msg  align-items-end">
                <p
                  className="ms-1 mb-0 text-uppercase"
                  style={{
                    color: `${corNomeOperadorCliente}`,
                    fontSize: '0.3rem',
                  }}
                >
                  Jose da Silva 20:51:22
                </p>
                <div
                  className="div-msg"
                  style={{
                    backgroundColor: `${corCaixaCliente}`,
                    borderRadius: '0.625rem 0rem 0.625rem 0.625rem',
                    maxWidth: '50%',
                  }}
                >
                  <div
                    style={{
                      color: `${corTextoCliente}`,
                      fontSize: '0.25rem',
                      textAlign: 'justify',
                    }}
                    className="text-html ms-2 me-2 fs-lg-1"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam congue nibh eget turpis sollicitudin aliquam convallis vitae eros. Vivamus pretium feugiat mi, ut consectetur lectus consectetur sed.',
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column mw-100 ms-md-4 me-md-3 ms-1 me-1
                 align-items-start"
            >
              <div className="d-flex flex-column mw-100 w-100 div-container-msg  align-items-start">
                <p
                  className="ms-1 mb-0 text-uppercase"
                  style={{
                    color: `${corNomeOperadorCliente}`,
                    fontSize: '0.3rem',
                  }}
                >
                  Administrador 20:52:11
                </p>
                <div
                  className="div-msg"
                  style={{
                    backgroundColor: `${corCaixaOperador}`,
                    borderRadius: '0rem 0.625rem 0.625rem',
                    maxWidth: '50%',
                  }}
                >
                  <div
                    style={{
                      color: `${corTextoOperador}`,
                      fontSize: '0.25rem',
                      textAlign: 'justify',
                    }}
                    className="text-html ms-2 me-2 fs-lg-1"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              width: '100%',
              height: '3rem',
              backgroundColor: '#fff',
              position: 'absolute',
              bottom: '1.8rem',
              zIndex: '1',
              opacity: '0.2',
            }}
          />
          <div
            className="editor-container position-absolute ms-4 me-4"
            style={{
              bottom: '2.3rem',
              width: '100%',
              opacity: '0.8',
              zIndex: '2',
            }}
          >
            <div className="editor-inner">
              <div style={{ background: 'transparent', display: 'flex' }}>
                <button className="button-text  border-0" type="button">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 16 16"
                    className="text-black"
                    height="0.5rem"
                    width="0.5rem"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8.21 13c2.106 0 3.412-1.087 3.412-2.823 0-1.306-.984-2.283-2.324-2.386v-.055a2.176 2.176 0 0 0 1.852-2.14c0-1.51-1.162-2.46-3.014-2.46H3.843V13H8.21zM5.908 4.674h1.696c.963 0 1.517.451 1.517 1.244 0 .834-.629 1.32-1.73 1.32H5.908V4.673zm0 6.788V8.598h1.73c1.217 0 1.88.492 1.88 1.415 0 .943-.643 1.449-1.832 1.449H5.907z" />
                  </svg>
                </button>
                <button className="button-text  border-0" type="button">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 16 16"
                    className="text-black"
                    height="0.5rem"
                    width="0.5rem"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.991 11.674 9.53 4.455c.123-.595.246-.71 1.347-.807l.11-.52H7.211l-.11.52c1.06.096 1.128.212 1.005.807L6.57 11.674c-.123.595-.246.71-1.346.806l-.11.52h3.774l.11-.52c-1.06-.095-1.129-.211-1.006-.806z" />
                  </svg>
                </button>
                <button className="button-text  border-0" type="button">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 16 16"
                    className="text-black"
                    height="0.5rem"
                    width="0.5rem"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M5.313 3.136h-1.23V9.54c0 2.105 1.47 3.623 3.917 3.623s3.917-1.518 3.917-3.623V3.136h-1.23v6.323c0 1.49-.978 2.57-2.687 2.57-1.709 0-2.687-1.08-2.687-2.57V3.136zM12.5 15h-9v-1h9v1z" />
                  </svg>
                </button>
                <button className="button-text border-0" type="button">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 16 16"
                    className="text-black"
                    height="0.5rem"
                    width="0.5rem"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                  </svg>
                </button>
                <div className="editor-placeholder">Digite sua mensagem</div>
                <div
                  className="buttonSendMessage"
                  style={{ marginTop: '1rem', marginLeft: '12rem' }}
                >
                  <button
                    type="submit"
                    id="btnSendMessage"
                    className="btn btn-primary btn-sm p-0 m-0 mb-1 pb-2"
                    style={{
                      width: '1rem',
                      height: '1rem',
                      borderRadius: '0.25rem',
                      backgroundColor: backgroundColorPrincipal ?? '#D1D1D1',
                      border: 0,
                    }}
                  >
                    <img
                      className="img-send-message"
                      style={{ width: '0.8rem', height: '0.8rem' }}
                      src={SendMessageIcon}
                      alt="Enviar Mensagem"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatArea;
